export default __webpack_public_path__ + "static/media/Andrea.2ff078b9.png";